import { IntlKey } from "../intl"

/**
 * A structured validation error returned by domain type `validate()` methods.
 *
 * Provides a generic way for domain types to report validation errors that can
 * be mapped to Zod issues with proper i18n support via {@link addValidationIssues}.
 */
export interface ValidationIssue {
  /** Domain-specific error code (e.g. "minLength", "invalidRegion") */
  readonly code: string

  /** IntlKey string for the user-facing error message */
  readonly message: IntlKey

  /** Optional interpolation data for parameterized translations */
  readonly data?: Record<string, string | number>
}

/**
 * Error thrown by domain type constructors when validation fails.
 * Carries structured {@link ValidationIssue}s that can be mapped to
 * Zod issues via {@link addValidationIssues}.
 */
export class ValidationError extends Error {
  readonly issues: ValidationIssue[]

  constructor(issues: ValidationIssue[]) {
    super(issues.map((i) => i.message).join(", "))
    this.name = "ValidationError"
    this.issues = issues
  }
}
